export const getSelectedFilterName = ({ selectedFilter }) => {
    return selectedFilter?.map((item) => item?.name).join(', ');
};
